export enum TRAVERSE {
  FORWARD = 'forward',
  REVERSE = 'reverse',
}
